import { render, staticRenderFns } from "./CardComunicados.vue?vue&type=template&id=b90f55ae&scoped=true&"
import script from "./CardComunicados.vue?vue&type=script&lang=js&"
export * from "./CardComunicados.vue?vue&type=script&lang=js&"
import style0 from "./CardComunicados.vue?vue&type=style&index=0&id=b90f55ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90f55ae",
  null
  
)

export default component.exports